import styled from "styled-components";
import { themeModules } from "../../../theme/theme.js"
import NuevaCuenta from "./nuevaCuenta.jsx"
import CuentasTable from "./cuentasTable.jsx"
import {useState,useEffect} from "react"
import api from '../../../axios.js'
import {useSelector} from "react-redux"


const Container = styled.div`
	background-color:${themeModules.background};
	color:white;
	height:100vh;
	display:flex;
	justify-content:start;
	align-items:center;
	flex-direction:column;
	overflow:scroll;
	box-Shadow:0 10px 20px 5px rgba(0,0,0,0.2); 
	&::-webkit-scrollbar{
		background-color:transparent;
		width:3px
	};
	&::-webkit-scrollbar-track{
		background:trasparent;		
		border-radius:25px
	};
	&::-webkit-scrollbar-thumb {
    	background: #27B0FE;
    	border-radius: 15px;
  	};
  	&::-webkit-scrollbar:horizontal{display:none}
`;

const PanelPrincipal = styled.div`
	background-color:${themeModules.panel};
	display:flex;
	justify-content:center;
	align-items:center;
	width:99%;
	border-radius:8px;
	margin:3px
`;



export default function CuentasAdmin(){
	let [cuentas,setCuentas]=useState([]);
	let estado=useSelector(state=>state.cuentas.estadoCuenta);
	let [cuentasFiltradas,setCuentasFiltradas]=useState([]);




	useEffect(()=>{
		let reloadData=async()=>{
			try{
				let data = await api("/cuenta");
				setCuentas(data.data);
				setCuentasFiltradas(data.data)
			}catch(err){
				console.log(err)
			}
		}; 
		if(estado==0){
			reloadData()	
		}
			
	},[estado])


	return(
		<Container >
			<PanelPrincipal>
					<NuevaCuenta/>												
			</PanelPrincipal>

			
			{cuentasFiltradas.length>0?<CuentasTable cuentas={cuentasFiltradas}/>:null}									
		</Container>)
}